export default __webpack_public_path__ + "static/media/menu-searchWhite.351ae00c.svg";